import { PROCORE_DOMAIN } from '../../../../utils/config/config';

// Procore's project admin page holds the stage and the contract/actual dates.
export const procoreProjectAdminUrl = (procoreId) => `https://${PROCORE_DOMAIN}/${procoreId}/project/admin`;
